$(document).ready(() => {
  $('.menu__item.more > a').click(function(e) {
    e.preventDefault();
    $(this).closest('.menu__item').toggleClass('is-active');
  });

  $(document).click(function(e) { 
    const $target = $(e.target);

    if (!$target.closest('.menu__item.is-active').length) {
      $('.menu__item.is-active').removeClass('is-active');
    }
  });

  initMobileMenu();
  initModals();
  initCatalogMenu();
  initCardsGrid();
  initTabs();
  initBannersSlider();
});


function initMobileMenu() {
  $('.header__menu-btn').click(function(e) {
    e.preventDefault();
    $('html').addClass('m-menu-active');
  });

  $('.m-menu__close').click(function(e) {
    e.preventDefault();
    $('html').removeClass('m-menu-active');
  });
}

function initModals() {
  $('.js-close-modal').click(function(e) {
    e.preventDefault();
    $(this).closest('.modal').removeClass('is-active');
    $('html').removeClass('modal-opened');
  });

  $('.js-open-modal').click(function(e) {
    e.preventDefault();
    $($(this).attr('data-modal')).addClass('is-active');
    $('html').addClass('modal-opened');
  });

  $('.js-submit-modal-form').click(function(e) {
    e.preventDefault();
    $(this).closest('.modal__form-wrap').addClass('show-result');
  });
}

function initCatalogMenu() {
  $('.catalog__menu a').click(function(e) {
    e.preventDefault();
    const parentLi = $(this).closest('li');

    if (!parentLi.hasClass('is-active')) {
      parentLi.addClass('is-active').siblings().removeClass('is-active');
      $($(this).attr('href')).addClass('is-active').siblings().removeClass('is-active');
      $(this).closest('.catalog').addClass('menu-screen-active');
    }
  });

  $('.catalog__main-back').click(function(e) {
    e.preventDefault();
    $(this).closest('.catalog').removeClass('menu-screen-active');
  });
}

function initCardsGrid() {
  $('.cards-grid').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1210,
        settings: 'unslick'
      }
    ]
  });
}

function initTabs() {
  $('.tabs a').click(function(e) {
    e.preventDefault();

    const parentLi = $(this).closest('li');

    if (!parentLi.hasClass('is-active')) {
      parentLi.addClass('is-active').siblings().removeClass('is-active');
      $($(this).attr('href')).addClass('is-active').siblings().removeClass('is-active');
    }
  });
}

function initBannersSlider() {
  $('.banners-slider').slick({
    dots: true,
    arrows: true
  });
}